export interface CashFlow {
  fund: string;
  date: string;
  openingValue: number;
  closingValue: number;
  netCashFlow: number;
  netChange: number;
}

export enum Periods {
  MONTH = 'month',
  QUARTER = 'quarter'
}

export interface CashFlowFilter {
  period: Periods;
  year?: number;
  month?: number;
  quarter?: number;
}

export interface CashFlowRequest {
  id: string;
  from: string;
  to: string;
  data?: CashFlow[];
  quarter?: number;
  period?: string;
  country?: string;
}
